<template>
 <div>
    <HeadDetailsGama  :titleHead="'Detalhes Imobiliária'" v-on:cancel="cancelNewAccredited" :btnCanceSave="true" v-on:save="onSubmit"></HeadDetailsGama>
    <b-form v-on:submit.prevent="onSubmit" class="ml-3 mr-3">

          <div class="title-1">Dados Básicos</div>
          <div class="pt1">
            <b-form-group
              class="w-75"
              id="input-group-name"
              label="Nome imobiliária:"
              label-for="input-name"
            >
              <b-form-input
                id="input-name"
                class="rounded form-control"
                name="input-name"
                type="text"
                v-validate="{  required: true }"
                v-model="editData.nome"
                :state="validateState('input-name')"
                placeholder="Digite o nome da credenciada"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="w-75"
              id="input-group-email"
              label="E-mail Comercial:"
              label-for="input-email"
            >
              <b-form-input
                id="input-email"
                name="input-email"
                class="rounded"
                v-validate="{ required: true, email: true }"
                v-model="editData.emailComercial"
                :state="validateState('input-email')"
                type="email"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="w-50"
              id="input-group-comercial-phone"
              label="Telefone Comercial:"
              label-for="input-comercial-phone"
            >
              <b-form-input
                id="input-comercial-phone"
                class="rounded"
                name="input-comercial-phone"
                v-validate="{ required: true, numeric: false, length:14 }"
                 v-model="editData.telefoneComercial"
                :state="validateState('input-comercial-phone')"
                type="text"
                v-mask="['(##) ####-####']"
                required
              >
              </b-form-input>
            </b-form-group>
          </div>
          <div class="pt1">
            <b-form-group
              class="dataCadastro"
              id="input-group-dateBirth"
              label="Data de Cadastro:"
              label-for="input-dateBirth"
            >
              <b-form-datepicker
                id="input-dateBirth"
                name="dateBirth"
                class="rounded"
                required
                :placeholder="$lang.Common.DatePlaceholder"
                v-validate="{ required: true }"
                v-model="editData.dataCadastro"
                :state="validateState('input-dateBirth')"
              ></b-form-datepicker>
            </b-form-group>
          </div>

            <div class = "titleRow">
              <div class="title-2">Endereço</div>
            </div>
            <div class="pt2">
            <b-form-group id="input-group-cep" class="cep" label="CEP:" label-for="input-cep">
              <b-form-input
                id="input-cep"
                name="input-cep"
                class="rounded"
                v-validate="{ required: true, numeric: false, length: 9 }"
                v-model="editData.cep"
                v-on:blur="searchAndress"
                :state="validateState('input-cep')"
                type="text"
                placeholder="_____-___"
                v-mask="['#####-###']"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="w-50"
              id="input-group-city"
              label="Cidade:"
              label-for="input-city"
            >
              <b-form-input
                id="input-city"
                name="input-city"
                :disabled="true"
                class="rounded"
                v-validate="{ required: true, alpha_spaces: true }"
                v-model="editData.cidade.nome"
                :state="validateState('input-city')"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="w-75"
              id="input-group-address"
              label="Endereço:"
              label-for="input-address"
            >
              <b-form-input
                id="input-address"
                name="input-address"
                class="rounded"
                :disabled="true"
                v-validate="{ required: true, alpha_spaces:true }"
                v-model="editData.endereco"
                :state="validateState('input-address')"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group
              class="w-75"
              id="input-group-district"
              label="Bairro:"
              label-for="input-district"
            >
              <b-form-input
                id="input-district"
                name="input-district"
                class="rounded"
                :disabled="true"
                v-validate="{ required: true, alpha_spaces: true }"
                v-model="editData.bairro"
                :state="validateState('input-district')"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
          </div>
          <div class="pt2">
            <b-form-group
              class="w-25"
              id="input-group-number"
              label="Número:"
              label-for="input-number"
            >
              <b-form-input
                id="input-number"
                name="input-number"
                class="rounded"
                v-validate="{ required: true }"
                v-model="editData.numero"
                :state="validateState('input-number')"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
              <b-form-group
              class="w-25"
              id="input-group-creci"
              label="CRECI:"
              label-for="input-creci"
            >
              <b-form-input
                id="input-creci"
                name="input-creci"
                class="rounded"
                v-validate="{ required: true }"
                v-model="editData.creci"
                :state="validateState('input-creci')"
                type="text"
                required
              ></b-form-input>
            </b-form-group>
            <b-form-group id="input-group-percentage"
              class="porcentagem"
              label="Percentual de comissão:"
              label-for="input-percentage">
              <b-form-input
                id="input-percentage"
                name="input-percentage"
                class="rounded"
                ref="input-percentage"
                v-model="editData.percentualComissao"
                v-validate="{ required: true }"
                v-on:blur="formatLazyPercentage"
                :state="validateState('input-percentage')"
                type="text"
                placeholder="Percentual de comsissão"
                required
                :formatter="formatPercentage"
              ></b-form-input>
            </b-form-group>
          </div>
      </b-form>
</div>
</template>

<script>
import Detailaccredited from './detailaccredited'
export default Detailaccredited
</script>

<style scoped>
.dataCadastro{
  width: 37%;
}
.float{
position:fixed;
width:60px;
height:60px;
bottom:40px;
right:40px;
background-color:#008148;
color:#FFF;
border-radius:50px;
text-align:center;
border: transparent;
}

.float:hover{
  background-color:#1f9c64;
}

.my-float{
margin-top: 23px;
margin-left: 2px;
}

.fa-plus:before {
    content: "\f067";
    color: white;
}

.title-modal{
  font: normal normal 600 18px/24px Segoe UI;
  letter-spacing: 0.27px;
  color: #404040;
  opacity: 1;
}

.form-nome-imobiliaria{
  top: 424px;
  left: 382px;
  width: 325px;
  height: 37px;
/* UI Properties */
  background: #FFFFFF 0% 0% no-repeat padding-box;
  border: 1px solid #CED4DA;
  border-radius: 4px;
  opacity: 1;
}

.pt1{
  margin-top: 1rem;
  display: flex;
  gap: 10px;
}

.pt2{
  margin-top: 1rem;
  display: flex;
  gap: 10px;
}

.plus-button{
  font: 20px;
  margin-top: 3px;
}
.container-buttons-form{
    display: flex;
    margin-bottom: 8%;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.button-cancel,
.button-save{
  margin-top: 10;
  outline: transparent;
  border: transparent;
  border-radius: 4px;
  text-transform: uppercase;
  width: 190px;
  height: 40px;
}

.button-cancel{
  background-color: #dedede;
  color: #747474;
}
.button-save{
  background-color: #008148;
  color: white;
}

.container-buttons-form{
    display: flex;
    justify-content: center;
    align-items: center;
    gap:15px;
}

.titleRow {
  grid-row: 3;
}

/* #input-group-uf-creci{
    grid-row: 2;
    grid-column: 10/11;
} */

.container-buttons-form{
    grid-row: 14;
    grid-column: 1/11;
    margin: 0;
    margin-top: 1%;
}

.form-control {
  font-size: 13px;
}
@media (min-width: 800px ) and (max-width: 1400px) {
  .title-2{
    grid-row: 3;
    color: #008148;
    font-size: 16px;
    margin-top: 5%;
    font-weight: 800;
  }
  .title-1{
    grid-row: 1;
    grid-column: 1/5;
    color: #008148;
    font-size: 16px;
    margin-top: 3%;
    font-weight: 800;
  }
  .cep{
    width: 45%;
  }
  .porcentagem{
    width: 23%;
  }
}

@media (min-width: 1401px ){
  .title-2{
    grid-row: 3;
    color: #008148;
    font-size: 18px;
    margin-top: 5%;
    font-weight: 800;
  }
  .title-1{
    grid-row: 1;
    grid-column: 1/5;
    color: #008148;
    font-size: 18px;
    margin-top: 3%;
    font-weight: 800;
  }
  .cep{
    width: 25%;
  }
  .porcentagem{
    width: 13%;
  }
}

</style>



// WEBPACK FOOTER //
// src/views/private/realestate/accredited/components/detailaccredited/detailaccredited.vue